import prismicApi from "src/store/config";

import { currentLocal } from "src/i18n";
import { routes } from "src/router";

/*
 ** Global
 */

// State
const state = {
    pages: {},
    currentPage: null,
    currentPageName: null,
    isFirstLoad: true
};

// Getters
const getters = {
    getPageByHandle: state => handle => state.pages[handle],
    getPageByUid: state => (handle, uid) => state.pages[handle].find(p => p.uid === uid),
    getSingleTitle: state => handle => state.pages[handle].data.label,
    getSinglePushLabel: state => handle =>
        state.pages[handle].data.page_push_label
            ? state.pages[handle].data.page_push_label
            : state.pages[handle].data.label,
    getNextEntrepreneur: state => handle => state.pages[handle].data,
    getRepeatable: state => (handle, uid) => state.pages[handle].find(page => page.uid === uid),
    getNextRepeatable: state => (handle, id) => {
        const repeatable = state.pages[handle];
        let index = repeatable.findIndex(page => page.id === id);

        // Get next element (first if last index)
        index = index === repeatable.length - 1 ? 0 : index + 1;

        return repeatable[index];
    }
};

// Actions
const actions = {
    // Initial data
    init(store) {
        return new Promise((resolve, reject) => {
            prismicApi.then(api =>
                api.query("", { lang: currentLocal.code }).then(r => {
                    let handle, single;
                    r.results.forEach(page => {
                        handle = page.type;

                        const route = routes.find(route => route.meta && route.meta.prismicHandle === handle);
                        const single = route ? !!route.meta.single : true;

                        if (single) {
                            store.state.pages[handle] = page;
                        } else {
                            // Create array if not defined yet
                            if (typeof store.state.pages[handle] === "undefined") {
                                store.state.pages[handle] = [];
                            }
                            // Add entry to array
                            store.state.pages[handle].push(page);

                            // Order by field
                            store.state.pages[handle].sort((a, b) => a.data.order - b.data.order);
                        }
                    });

                    resolve(true);
                })
            );
        });
    },
    loadContent(store, route) {
        return new Promise((resolve, reject) => {
            const handle = route.meta.prismicHandle;
            const single = route.meta.single;
            let page;

            if (single) {
                page = store.getters.getPageByHandle(handle);
                store.dispatch("updateCurrentPage", page);
            } else {
                const uid = route.params.uid;
                page = store.getters.getRepeatable(handle, uid);
                store.dispatch("updateCurrentPage", page);
            }

            // Update page name
            store.commit("setPageName", handle);

            resolve(page);
        });
    },
    updateCurrentPage(store, page) {
        store.commit("setPage", page);
    }
};

// Mutations
const mutations = {
    setPage(state, page) {
        state.currentPage = page;
    },
    setPageName(state, name) {
        state.currentPageName = name;
    },
    toggleFirstLoad(state, bool) {
        // update the background color of the app after the user loaded for the first time.
        // This will avoid spending too much time refactor everything else because there is many component without any background colors
        state.isFirstLoad = bool;
    }
};

// Export module
export default {
    state,
    getters,
    actions,
    mutations,
    namespaced: true
};
